'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosReverseCameraOutline = function IoIosReverseCameraOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.6 24.9l0.2-0.1 0.8 0.9-0.1 0.2c-1.3 1.1-2.9 1.6-4.5 1.6-3.5 0-6.4-2.8-6.8-6.1h-2.3l2.9-3.9 3.1 3.9h-2.4c0.3 2.6 2.7 4.9 5.5 4.9 1.3 0 2.6-0.5 3.6-1.4z m1.1-9.4c1.2 1.1 1.9 2.9 2.1 4.5h2.3l-2.9 4-3.1-4h2.4c-0.3-2.7-2.7-5-5.5-5-1.3 0-2.6 0.5-3.6 1.3l-0.1 0.2-0.9-1 0.1-0.1c1.3-1.1 2.9-1.7 4.5-1.7 1.7 0 3.4 0.7 4.7 1.8z m8-3c1.4 0 2.3 1.1 2.3 2.4v13.8c0 1.3-0.9 2.6-2.3 2.6h-25c-1.4 0-2.7-1.3-2.7-2.6v-13.8c0-1.3 1.3-2.4 2.7-2.4h1v-1.2h2.6v1.2h1c2.5-2.8 3.4-3.7 4.3-3.7h6.9c1 0 1.8 0.9 4.3 3.7h4.9z m1.1 16.2v-13.8c0-0.7-0.4-1.1-1.1-1.1h-5.4s-0.3-0.1-0.4-0.3-0.5-0.6-0.7-0.8c-1-1.1-1.7-1.9-2.1-2.4-0.4-0.4-0.6-0.3-0.6-0.3h-6.9s0 0-0.4 0.3c-0.5 0.4-1.2 1.1-2.1 2.1-0.2 0.3-0.6 0.9-0.8 1.1s-0.3 0.3-0.5 0.3h-5.1c-0.7 0-1.4 0.5-1.4 1.1v13.8c0 0.7 0.7 1.3 1.4 1.3h25c0.6 0 1.1-0.6 1.1-1.3z' })
        )
    );
};

exports.default = IoIosReverseCameraOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-reverse-camera-outline.js
// module id = 2752
// module chunks = 168707334958949